export default __webpack_public_path__ + "static/womens-health-2c1f0ce8325c8bc9d724ac4556a2d972.jpg";